<script lang="ts">
  // The header of every app page: optional back link, title (Syne, as on
  // timepeak.nl), subtitle, meta badges and actions on the right.
  //   <PageHeader title={t('nav.clients')} subtitle={t('clients.subtitle')}>
  //     {#snippet actions()}<Button variant="primary">…</Button>{/snippet}
  //   </PageHeader>
  //   <PageHeader title={client.name} back={{ href: '/app/klanten', label: t('nav.clients') }}>
  //     {#snippet leading()}<Avatar name={client.name} size={44} />{/snippet}
  //     {#snippet meta()}<Badge tone="success">Actief</Badge>{/snippet}
  //   </PageHeader>
  // `children` render under the header row (tabs, filters). On phones the
  // actions wrap under the title.
  import type { Snippet } from 'svelte';
  import BackLink from './BackLink.svelte';

  interface Props {
    title: string;
    subtitle?: string;
    /** Small uppercase line above the title. */
    eyebrow?: string;
    /** Back link above the title: a URL or { href, label }. */
    back?: string | { href: string; label?: string };
    size?: 'md' | 'sm';
    /** No bottom margin (when something directly follows, e.g. tabs). */
    flush?: boolean;
    leading?: Snippet;
    meta?: Snippet;
    actions?: Snippet;
    children?: Snippet;
    class?: string;
  }
  let { title, subtitle, eyebrow, back, size = 'md', flush = false, leading, meta, actions, children, class: cls = '' }: Props = $props();
  const backLink = $derived(typeof back === 'string' ? { href: back, label: undefined } : back);
</script>

<header class="ph {size} {cls}" class:flush>
  {#if backLink}<BackLink href={backLink.href} label={backLink.label} />{/if}
  <div class="bar">
    <div class="lead">
      {#if leading}<div class="leading">{@render leading()}</div>{/if}
      <div class="titles">
        {#if eyebrow}<span class="eyebrow">{eyebrow}</span>{/if}
        <div class="title-line">
          <h1 class="title">{title}</h1>
          {#if meta}<div class="meta">{@render meta()}</div>{/if}
        </div>
        {#if subtitle}<p class="subtitle">{subtitle}</p>{/if}
      </div>
    </div>
    {#if actions}<div class="actions">{@render actions()}</div>{/if}
  </div>
  {#if children}<div class="below">{@render children()}</div>{/if}
</header>

<style>
  .ph { display: flex; flex-direction: column; gap: var(--space-2); margin-bottom: var(--space-6); min-width: 0; }
  .flush { margin-bottom: 0; }
  .bar { display: flex; align-items: flex-end; justify-content: space-between; gap: var(--space-4); flex-wrap: wrap; min-width: 0; }
  .lead { display: flex; align-items: center; gap: var(--space-3); min-width: 0; flex: 1 1 320px; }
  .leading { display: flex; flex-shrink: 0; }
  .titles { display: flex; flex-direction: column; gap: var(--space-1); min-width: 0; }
  .title-line { display: flex; align-items: center; gap: var(--space-2_5); flex-wrap: wrap; min-width: 0; }
  .title {
    font-family: var(--font-display);
    font-size: var(--text-3xl);
    font-weight: var(--weight-bold);
    letter-spacing: var(--tracking-tight);
    line-height: var(--leading-tight);
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .sm .title { font-size: var(--text-2xl); }
  .meta { display: flex; align-items: center; gap: var(--space-1_5); flex-wrap: wrap; }
  .subtitle { color: var(--text-2); font-size: var(--text-md); max-width: 70ch; }
  .actions { display: flex; align-items: center; gap: var(--space-2); flex-wrap: wrap; }
  .below { margin-top: var(--space-2); min-width: 0; }
  @media (max-width: 760px) {
    .title { font-size: var(--text-2xl); }
    .sm .title { font-size: var(--text-xl); }
    .ph { margin-bottom: var(--space-5); }
    .flush { margin-bottom: 0; }
    .actions { width: 100%; }
  }
</style>
